import { CopyOutlined } from '@ant-design/icons'
import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { GenericObject, RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { ToolBox } from 'app/lib/hooks/toolBox'
import useTranslation from 'app/lib/hooks/useTranslation'
import { notify } from 'app/lib/Notify'
import { copyRichText } from 'app/lib/utils/copy-text'
import * as React from 'react'
import { useRef } from 'react'

import RequestText from './RequestText'

const CopyRequestTextInfo: React.FC<MemberProps<IRental>> = ({ member }) => {
  const { tComponent, tButtonTitle } = ToolBox.useString()
  const { tModal } = useTranslation({ recordType: RecordType.copy_request })
  const { buttonId } = ToolBox.useId()
  const {
    modalify: { open }
  } = useFeedbacker()
  const ref = useRef<HTMLDivElement>()

  const translate = (id: string, values?: GenericObject<string | number>) =>
    tComponent({
      recordType: RecordType.rental,
      componentType: 'data_display',
      componentName: 'card',
      id,
      values
    })

  const notifyOnConfirm = (intent: 'success' | 'danger') => {
    const message = tModal({
      id: intent
    })
    notify({ message, intent })
  }

  const onConfirm = () => {
    try {
      copyRichText(ref.current.innerHTML)
      notifyOnConfirm('success')
    } catch (err) {
      console.error(err.name, err.message)
      notifyOnConfirm('danger')
    }
  }

  const onClick = () => {
    open({
      recordType: RecordType.copy_request,
      action: 'copy_text',
      titleTranslationValues: { rental_code: member.rental_code },
      content: <RequestText member={member} props={{ ref }} />,
      onConfirm,
      modalType: 'default'
    })
  }

  return (
    <Alert
      showIcon
      closable
      icon={<CopyOutlined />}
      type="default"
      message={<b>{translate('copy_request_text_title', { rental_code: member.rental_code })}</b>}
      description={
        <Row align="middle" justify="space-between" gutter={[12, 12]}>
          <KCol>{translate('copy_request_text_description')}</KCol>
          <KCol>
            <Button
              title={tButtonTitle({
                recordType: RecordType.copy_request,
                action: 'copy_request_text'
              })}
              type="primary"
              id={buttonId({ recordType: RecordType.rental, action: 'copy_request_text' })}
              onClick={onClick}
            />
          </KCol>
        </Row>
      }
    />
  )
}

export default CopyRequestTextInfo
